import type React from "react";
import {useCallback, useEffect} from "react";
import {useAuthState} from "react-firebase-hooks/auth";
import {useParams} from "react-router-dom";

import {faBars} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {usePersonalBestV2RealtimeSub} from "~/api/hooks/usePersonalBestV2";
import CustomButton from "~/component/common/CustomButton";
import {useGlobalEvent} from "~/contexts/event/GlobalEventBusContext";
import {auth} from "~/firebase/firebase";

import useModal from "../../../../hooks/useModal";
import PlayMenuContent from "./PlayMenuContent";

const PlayMenuModalButton: React.FC = () => {
  const {id} = useParams<{id: string}>();
  const {openModal, closeModal, Modal} = useModal();
  const [myUser] = useAuthState(auth);

  // Automatically open the Modal when loading a new level.
  useEffect(() => {
    openModal();
  }, [openModal, id]);

  // Wrap the callback in useCallback to provide a stable reference.
  const handleNewPersonalBest = useCallback(() => {
    setTimeout(() => openModal());
  }, [openModal]);

  useGlobalEvent("new-personal-best", handleNewPersonalBest);

  usePersonalBestV2RealtimeSub({
    levelId: id,
    id: myUser?.uid,
  });

  return (
    <>
      <CustomButton
        onClick={openModal}
        aria-label="Open menu"
        className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
      >
        <FontAwesomeIcon
          icon={faBars}
          size="xl"
          className="text-white p-2 -m-2 rounded-full pl-2.5 pr-2.5 bg-gradient-to-br from-blue-600 via-blue-500 to-black"
        />
      </CustomButton>
      <Modal>
        <PlayMenuContent closeModal={closeModal} />
      </Modal>
    </>
  );
};

export default PlayMenuModalButton;
